import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageBody } from "@/components/Page";
import { Badge } from "@/components/ui/badge";
import { ContactBody } from "@/components/ContactDetail";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import api from "@/lib/api";

export default function ContactPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => { api.get(`/contacts/${id}`).then((r) => setD(r.data)).catch(() => setD(false)); }, [id]);
  const c = d && d.contact;
  useDocumentTitle(c ? c.name : "Contact");

  return (
    <PageBody>
      <button onClick={() => navigate("/app/contacts")} className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5 mb-4" data-testid="contact-back"><ArrowLeft className="h-4 w-4" /> All contacts</button>
      {d === false ? (
        <p className="text-sm text-muted-foreground">Contact not found.</p>
      ) : c ? (
        <>
          <div className="mb-6">
            <div className="flex items-center gap-2">
              <h1 className="font-display text-2xl font-semibold tracking-tight">{c.name}</h1>
              {d.in_sequence && <Badge className="bg-amber-500/15 text-amber-500 border-0 text-[10px]">In sequence</Badge>}
            </div>
            <p className="text-sm text-muted-foreground font-mono">{c.title || "-"} · {c.company || "-"}</p>
          </div>
          <div className="rounded-xl border border-border/70 bg-card/50 p-6" data-testid="contact-detail-page"><ContactBody d={d} /></div>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Loading contact…</p>
      )}
    </PageBody>
  );
}
